'use client'
import type { PropsWithChildren } from 'react'
import type { ModalHeaderAccentProps } from '../organisms/modal-header/modal-header-accent.tsx'
import { ModalHeader } from '../organisms/modal-header/modal-header.tsx'

export type ConfirmationModalHeaderProps = PropsWithChildren<{
  hideAccent?: boolean
  accent?: ModalHeaderAccentProps
}>

const defaultAccentProps: ModalHeaderAccentProps = {
  name: 'ExclamationCircleIcon',
  color: 'negative',
}

export const ConfirmationModalHeader = ({
  accent,
  hideAccent,
  children,
}: ConfirmationModalHeaderProps) => {
  const accentProps = {
    ...defaultAccentProps,
    ...accent,
  }

  return (
    <ModalHeader>
      {!hideAccent && <ModalHeader.Accent {...accentProps} />}
      <ModalHeader.Main>
        <ModalHeader.Title>{children}</ModalHeader.Title>
      </ModalHeader.Main>
    </ModalHeader>
  )
}
